import { render, staticRenderFns } from "./ModalTempoCirurgicoPorProcedimento.vue?vue&type=template&id=78ba1100&scoped=true"
import script from "./ModalTempoCirurgicoPorProcedimento.vue?vue&type=script&lang=ts"
export * from "./ModalTempoCirurgicoPorProcedimento.vue?vue&type=script&lang=ts"
import style0 from "./ModalTempoCirurgicoPorProcedimento.vue?vue&type=style&index=0&id=78ba1100&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ba1100",
  null
  
)

export default component.exports